<template>
    <div class="hero-box-preset1" v-if="image">
        <img v-if="displayType === 'cropped'" :src="image" class="img img-fluid w-100 cropped" />
        <img v-if="displayType === 'full'" :src="image" class="img img-fluid w-100 full" />
        <div class="inner">
            <div class="holder">
                <h1 v-html="title" :style="{ color: color }"></h1>
                <ul class="list-checked" v-if="entries" :style="{ color: color }">
                    <li
                        v-if="entries"
                        v-for="entry in entries"
                        :style="{'--color': color}"
                    >
                        <span v-html="entry"></span>
                    </li>
                </ul>
                <div class="btn-container">
                    <b-link v-if="buttonText && buttonLink" :href="buttonLink" class="btn btn-hero" :target="target">
                        {{ buttonText }}
                    </b-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BLink } from 'bootstrap-vue';

export default {
    name: 'LandingPageHeroBoxDefault',
    components: {
        BLink
    },
    props: {
        image: {
            type: String,
            required: true
        },
        title: {
            type: String
        },
        entries: {
            type: Array
        },
        buttonText: {
            type: String
        },
        buttonLink: {
            type: String
        },
        target: {
            type: String
        },
        color: {
            type: String,
            default: '#fff'
        },
        displayType: {
            type: String
        }
    },
    
}
</script>

<style scoped>
    ul.list-checked li::before {
      background-color: var(--color);
   }
</style>